import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-black text-white py-12 mt-20">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Logo & Company */}
          <div>
            <img src="/hi-tec-logo.png" alt="HI-TEC" className="h-10 mb-4" />
            <p className="text-gray-400 text-sm">
              Plataforma B2B para distribuidores
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contacto</h3>
            <div className="text-gray-300 text-sm space-y-2">
              <p className="font-semibold text-white">HI-TEC SPORTS ESPAÑA S.A.</p>
              <p>Elche Parque Empresarial</p>
              <p>Calle Antonio Gaudí, 12</p>
              <p>03203 Elche (Alicante)</p>
            </div>
          </div>

          {/* Commercial Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4">Atención Comercial</h3>
            <div className="text-gray-300 text-sm space-y-2">
              <p className="font-semibold text-white">David García</p>
              <p>
                <span className="text-gray-400">Móvil:</span>{' '}
                <a href="tel:+34618050398" className="text-blue-400 hover:text-blue-300 transition">
                  +34 618 050 398
                </a>
              </p>
              <p>
                <span className="text-gray-400">Email:</span>{' '}
                <a href="mailto:david@gescomsport.com" className="text-blue-400 hover:text-blue-300 transition">
                  david@gescomsport.com
                </a>
              </p>
            </div>
            <div className="text-gray-300 text-sm space-y-2 mt-6">
              <p className="font-semibold text-white">Curro Gutiérrez</p>
              <p>
                <span className="text-gray-400">Móvil:</span>{' '}
                <a href="tel:+34610128693" className="text-blue-400 hover:text-blue-300 transition">
                  +34 610 12 86 93
                </a>
              </p>
              <p>
                <span className="text-gray-400">Email:</span>{' '}
                <a href="mailto:curro@gescomsport.com" className="text-blue-400 hover:text-blue-300 transition">
                  curro@gescomsport.com
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-6 text-center">
          <p className="text-gray-400 text-sm">
            © 2025 HI-TEC SPORTS ESPAÑA S.A. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
